
import React from 'react'
import { createPortal } from 'react-dom'

interface IProps {
    enable?: boolean
    children: JSX.Element
    nodeRef?: React.RefObject<HTMLElement>
}

export default function FloatingPortal({ children, nodeRef, enable}: IProps) {

    if (!enable) {
        return children
    }
    if (typeof window === 'undefined' && !nodeRef) {
        return null
    }
    const node = nodeRef?.current || document.body
    return createPortal(children, node)
}
